<template>


  <v-container fluid class="repairRequest-management mt-4 px-1">
    <v-row>


        <v-overlay :value="isLoadingSave" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>


      <!-- Modal ชื่อ dialogRemark -->
      <v-dialog v-model="dialogRemark" max-width="850px">
        <v-card>
          <v-card-title>
            <span class="text-h6">สถานะเอกสาร</span>
          </v-card-title>
          <v-card-text>

            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                :headers="remark_headers"
                :items="remark_items"
                item-value="id"
            >
              <!-- Template สำหรับคอลัมน์ updated_at -->
              <template v-slot:item.updated_at="{ item }">
                <span>{{ dataFormatter.dateFormatterTH(item.updated_at, 1) }}</span>
              </template>


              <template v-slot:item.request_status="{ item }">

    <span
        v-if="getStatusData(item.request_status)"
        :class="`v-chip theme--light v-size--small ${getStatusData(item.request_status).color}`"
    >
      <span class="v-chip__content">{{ getStatusData(item.request_status).title_th }}  </span>
    </span>
                <span v-else class="v-chip theme--light v-size--small default">
      <span class="v-chip__content">สถานะไม่ทราบ</span>
    </span>

              </template>


            </v-data-table>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                outlined
                class="button-shadow mr-4"
                @click="dialogRemark = false"
            >
              ปิด
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>รายการแจ้งซ่อมวัสดุอุปกรณ์</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + repairRequests.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      @change="searchData"
                      v-model="search_data.request_status"
                      :items="return_status_text_color"
                      item-text="title_th"
                      item-value="status_code"
                      label="สถานะการดำเนินการ"
                      clearable=""
                  ></v-select>


                </v-col>



                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>

            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="repairRequests"
                :search="search"
                sort-by="request_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"

                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.request_h_image="{ item }">

                <a :href="baseURLStorage + item.request_h_image" target="_blank">
                  <v-avatar tile>
                    <img
                        :src="baseURLStorage + item.request_h_image"
                        :alt="item.item_detail"
                    >
                  </v-avatar>
                </a>


              </template>

              <template v-slot:item.created_at="{ item }">
                <span>{{ dataFormatter.dateFormatterTH(item.created_at, 3) }}</span>
              </template>


              <template v-slot:item.request_status="{ item }">
                      <span v-if="getStatusData(item.request_status)"
                            :class="`v-chip theme--light v-size--small ${getStatusData(item.request_status).color}`">
                        <span class="v-chip__content">{{ getStatusData(item.request_status).title_th }}  </span>
                      </span>
                <span v-else class="v-chip theme--light v-size--small default">
                        <span class="v-chip__content">สถานะไม่ทราบ</span>
                      </span>

                <v-btn icon small @click="showRemark(item.request_id)">
                  <v-icon color="greyTint" title="สถานะเพิ่มเติม">mdi-information</v-icon>
                </v-btn>

              </template>


              <template v-slot:item.api="{ item }">



                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                    :disabled="!return_status_text_color.find(items => items.status_code === item.request_status).edit && checkAdmin!='Y'"

                >แก้ไข
                </v-btn>


                <!--                <v-btn
                                    @click="deleteItem(item)"
                                    small
                                    class="button-shadow"
                                    color="secondary"

                                >ลบข้อมูล
                                </v-btn>-->


                <v-menu offset-y v-if="checkAdmin=='Y'" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-3 button-shadow"
                        color="primary"
                        small
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                      เปลี่ยนสถานะ
                    </v-btn>
                  </template>

                  <v-list>
                    <div class="custom-grid">
                      <v-list-item
                          v-for="(item2, index) in return_status_text_color"
                          :key="index"
                          @click="updateStatusItem(item.request_id,item2.status_code,item2.title_th)"

                      >
                        <v-list-item-title>
                          {{index+1}}.{{ item2.title_th }}  <v-icon small color="success" v-show="item.request_status==item2.status_code">mdi-check-circle</v-icon>
                        </v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>






                <v-btn
                    @click="updateStatusItem(item.request_id,3,'ยกเลิก')"
                    small
                    class="button-shadow"
                    color="secondary"
                    :disabled="!return_status_text_color.find(items => items.status_code === item.request_status).cancel  && checkAdmin!='Y' "
                >ยกเลิก
                </v-btn>

              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.request_id"
                      label="รหัสแจ้งซ่อมวัสดุอุปกรณ์"
                      required
                      disabled
                      v-if="state=='addForm'"
                  ></v-text-field>

                  <v-text-field
                      v-model="editForm.request_id"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="รหัสแจ้งซ่อมวัสดุอุปกรณ์"
                      required
                      readonly
                      disabled
                      v-else
                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.created_at_text"
                      :rules="editForm.textReqRules"
                      label="วันที่เอกสาร"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.full_name_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อ-นามสกุล (ผู้แจ้ง)"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.email"
                      label="Email"
                      required
                      disabled
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.info_mobile"
                      :rules="editForm.textReqRules"
                      label="หมายเลขโทรศัพท์"
                      required
                  ></v-text-field>


                </v-col>


              </v-row>



              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="12">

                  <v-text-field
                      v-model="editForm.item_detail"
                      :rules="editForm.textReqRules"
                      label="รายละเอียดอุปกรณ์ที่ชำรุด"
                      required
                  ></v-text-field>


                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.remarks"
                      :rules="editForm.textReqRules"
                      label="หมายเหตุเพิ่มเติม สถานที่ รหัสอุปกรณ์ คำอธิบายอื่นๆ "

                  ></v-text-field>


                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบ"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบ"
                  ></v-file-input>


                </v-col>


                <!--*************************************************-->

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-img
                        :src="baseURLStorage+editForm.avatarFileOld"
                        :alt="editForm.item_detail"
                        style="max-width: 100%"
                    ></v-img>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อใหม่ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบหัวข้อใหม่ (TH) "
                  ></v-file-input>


                </v-col>

                <!--*************************************************-->


              </v-row>



              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>

    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import dataFormatter from "@/use/dataFormatter";
import axios from "axios";

export default {
  name: 'RepairRequest',
  data() {
    return {
      modal: false,
      dialogRemark: false,
      isLoadingSave: false, // ตัวแปรสถานะการโหลด
      state: 'index',
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      search: '',
      search_data: {
        request_status: "",

      },
      selected: [],
      headers: [
        {
          text: 'รหัสแจ้งซ่อม',
          align: 'start',
          value: 'request_id',
        },
        {
          text: 'ภาพ',
          value: 'request_h_image',
        },
        {
          text: 'วันที่เอกสาร',
          value: 'created_at',
        },
        {text: 'รายการแจ้งซ่อม', value: 'item_detail'},

        {text: 'สถานะ', value: 'request_status'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ["request_id"],
        sortDesc: [true]
      },


      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
      },
      temp_data: null,
      return_status_text_color: [
        {
          "status_code": 0,
          "title_th": "รอการตรวจสอบ",
          "color": "warning",
          "edit": true,
          "cancel": true,
        },
        {
          "status_code": 1,
          "title_th": "รับเรื่องแล้ว อยู่ระหว่างดำเนินการ",
          "color": "default",
          "edit": false,
          "cancel": false,
        },
        {
          "status_code": 2,
          "title_th": "ดำเนินการเสร็จสิ้น",
          "color": "success",
          "edit": false,
          "cancel": false,
        },
        {
          "status_code": 3,
          "title_th": "ยกเลิก",
          "color": "warning",
          "edit": false,
          "cancel": false,
        }
      ],
      remark_items: [],
      remark_headers: [

        {text: 'สถานะเอกสาร', value: 'request_status'},
        {text: 'หมายเหตุ', value: 'remark'},
        {text: 'วันที่ทำรายการ', value: 'updated_at'},
        {text: 'บันทึกโดย', value: 'created_by'},

      ],
      checkAdmin:0,
    }
  },
  components: {},
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('repair_requests', ['repairRequests', "isReceiving", "isDeleting", "idToDelete", "repairRequestMessage", "isUpdating", "errorMessage"]),

    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //getDataUserLogin
    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),

    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    repairRequestMessage() {

      if (this.repairRequestMessage !== '') {
        this.notification = this.repairRequestMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    },

  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getRepairRequestsRequest(this.search_data);
    this.getCheckAdmin()
    this.resetValue();
  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('repair_requests',
        [
          "getRepairRequestsRequest",
          "deleteRepairRequestRequest",
          "updateRepairRequestRequest",
          "createRepairRequestRequest",
          "updateStatusRepairRequest"
        ]
    ),

    async showAlertChangeStatus(id,text) {
      const result = await this.$swal({
        title: "โปรดยืนยัน!",
        text: "คุณต้องการเปลี่ยนสถานะรายการ ("+id+") เป็น "+text+" ใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        input: 'text',
        allowOutsideClick: false, // Prevent closing by clicking outside
      });

      return result;
    },


    resetValue() {
      this.editForm = {} //set null all value
      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        request_id: null,
        info_mobile: '',
        item_detail: '',
        request_status: 0,
        remarks: '#',
        preview: '',
        avatarFile: null,
        avatarFileOld: null,
        request_h_image: null
      }
    },



    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },

    addItem() {
      console.log(this.currentUser)

      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.created_at_text = dataFormatter.dateFormatterTH(new Date(), 3);
      this.editForm.email = this.currentUser.email;
      this.editForm.full_name_th = this.currentUser.fname_th + ' ' + this.currentUser.lname_th;
      // this.editForm.info_mobile = this.currentUser.info_mobile;
      this.editForm.request_status = 0;
      this.editForm.request_id = 'AUTO'
      this.editForm.remarks = '#'
      this.state = 'addForm';
    },
    editItem(item) {
      this.resetValue();
      this.editedIndex = this.repairRequests.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.created_at_text = dataFormatter.dateFormatterTH(item.created_at, 3);
      this.editForm.email= item.email;
      this.editForm.full_name_th= item.fname_th + ' ' + item.lname_th;
      this.editForm.info_mobile = item.info_mobile;
      this.editForm.item_detail = item.item_detail;
      this.editForm.request_status = item.request_status;
      this.editForm.remarks = item.remarks;
      this.editForm.avatarFileOld = item.request_h_image;
      this.editForm.request_id = item.request_id * 1;
      this.editForm.active = item.active;
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteRepairRequestRequest({request_id: item.request_id})

    },

    close() {

      if (this.errorMessage == false || this.repairRequestMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    async save() {
      this.isLoadingSave = true;

      try {
        if (this.editedIndex > -1) {
          await this.updateRepairRequestRequest(this.editForm); // ✅ ตอนนี้ await จะรอจริง
        } else {
          await this.createRepairRequestRequest(this.editForm);
        }

        this.addSuccessNotification(); // ✅ ตอนนี้เรียกหลังทุกอย่างเสร็จจริง
      } catch (e) {
        this.addErrorNotification();
      } finally {
        this.isLoadingSave = false;
      }
    }
    ,
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },

    searchData() {
      this.getRepairRequestsRequest(this.search_data);
    },
    getStatusData(status) {

      return this.return_status_text_color.find((item) => item.status_code === status) || null;
    },



    async updateStatusItem(request_id, request_status, text) {

      try {
        const isConfirmed = await this.showAlertChangeStatus(request_id, text);
        if (isConfirmed.isConfirmed) {
          this.isLoadingSave = true; // Start loading
          await this.updateStatusRepairRequest({
            request_id: request_id,
            request_status: request_status,
            remark: text + ":" + isConfirmed.value,
          });
          this.addSuccessNotification();
        }
      } catch (error) {
        this.addErrorNotification();
      } finally {
        this.isLoadingSave = false; // Stop loading
      }
    },
    toggleLoading() {
      this.isLoadingSave = !this.isLoadingSave;
      console.log("isLoadingSave:", this.isLoadingSave);
    },
    showRemark(request_id) {
      this.remark_items = [];
      try {
        const formData = new FormData();

        formData.append('request_id', request_id);

        axios.post(config.baseURLApi + '/get_repair_requests_log', formData, {
          headers: {},
        }).then(res => {
          console.log(res.data)
          this.remark_items = res.data
          this.dialogRemark = true

        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },
    async getCheckAdmin() {

      try {

        const formData = new FormData();
        formData.append('role_group', 'repair');
        formData.append('role_page', '/repair/request');
        formData.append('check_role', '');

        await axios.post(config.baseURLApi + '/api/getRoleUserWeb/' , formData, {
          headers: {},
        }).then(res => {

        //  this.checkAdmin = res.data;
          if (res.data.length>0){
            this.checkAdmin = res.data[0].super_admin;
          }
        });


      } catch (e) {
        this.showSnackbar(e);
      }


    },
    async beforeMount() {
    },

  },
}
</script>

<style src="../RepairRequest/RepairRequest.scss" lang="scss"/>
